var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.878,
    height: 50.018,
    viewBox: "0 0 49.878 50.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(-1543.468 51.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(1543.617 -49.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1575.684,5.548h-6.829V-13.238h6.829Zm-24.457-25.592H1544.4V-41.381h6.829Z",
    transform: "translate(-1544.398 41.381)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(1543.468 -39.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1581.855,42a5.97,5.97,0,0,1-6.893-2.472l-1.219-1.828-1.054-1.582,2.273-3.407A6.145,6.145,0,1,1,1581.855,42Zm-20-2.472a6.146,6.146,0,1,1-6.9-9.29,6.509,6.509,0,0,1,1.884-.281,5.87,5.87,0,0,1,5.012,2.754l2.273,3.407-2.273,3.409Zm22.065-16.111a13.038,13.038,0,0,0-14.887,5.342l-.626.936-.624-.936a13.272,13.272,0,0,0-24.315,7.362,13.273,13.273,0,0,0,24.315,7.36l.624-.938.626.938c.14.209.282.413.431.61a12.956,12.956,0,0,0,10.469,5.329,13.779,13.779,0,0,0,3.99-.6,13.272,13.272,0,0,0,0-25.4Z",
    transform: "translate(-1543.468 -22.812)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(1568.072 -25.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1702.352,106.943l-4.565,6.818q-.237-.316-.459-.651l-.668-1,4.568-6.854,1.125,1.687Z",
    transform: "translate(-1696.659 -105.256)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(1563.074 -33.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M1670.877,57.11,1666.6,63.5c-.149-.2-.291-.4-.431-.61l-.626-.937,4.282-6.424,1.054,1.582Z",
    transform: "translate(-1665.541 -55.528)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(1543.7 -51.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1548.241-51.03a4.013,4.013,0,0,1,3.332,1.56h-6.664a4.012,4.012,0,0,1,3.332-1.56Z",
    transform: "translate(-1544.909 51.03)",
    fill: "#dedede",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(1568.204 -2.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M1700.771,252.35a3.959,3.959,0,0,0,3.287-1.539h-6.574a3.959,3.959,0,0,0,3.287,1.539Z",
    transform: "translate(-1697.484 -250.811)",
    fill: "#dedede",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.449bbb76c0803feaa754aabd711cc0ea.svg";
export { ForwardRef as ReactComponent };